import React from 'react';
import { LayoutDashboard, Users, UserCheck, CreditCard, CheckSquare, BarChart3, Settings, Bell, ChevronRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const NAV = [
  { section: 'Main', items: [
    { label: 'Dashboard',         icon: LayoutDashboard, page: 'dashboard',  roles: ['admin','tl','consultant'] },
    { label: 'Leads Pipeline',    icon: Users,           page: 'leads',      roles: ['admin','tl','consultant'] },
    { label: 'Enrolled Clients',  icon: UserCheck,       page: 'clients',    roles: ['admin','tl','consultant'] },
    { label: 'Follow-ups',        icon: Bell,            page: 'followups',  roles: ['admin','tl','consultant'] },
  ]},
  { section: 'Finance', items: [
    { label: 'Payments',          icon: CreditCard,      page: 'payments',   roles: ['admin','tl','consultant'] },
    { label: 'Retainer Billing',  icon: CreditCard,      page: 'retainer',   roles: ['admin','tl'] },
    { label: 'Approvals',         icon: CheckSquare,     page: 'approvals',  roles: ['admin','tl'] },
  ]},
  { section: 'Management', items: [
    { label: 'Reports',           icon: BarChart3,       page: 'reports',    roles: ['admin','tl'] },
    { label: 'Settings',          icon: Settings,        page: 'settings',   roles: ['admin'] },
  ]},
];

export default function Sidebar({ currentPage, onNavigate }) {
  const { user } = useAuth();
  const role = user?.role;

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">⚖</div>
        <div>
          <div className="sidebar-brand">Easy Settlement</div>
          <div className="sidebar-sub">CRM v2.0</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {NAV.map(section => {
          const items = section.items.filter(i => i.roles.includes(role));
          if (!items.length) return null;
          return (
            <div key={section.section} className="nav-section">
              <div className="nav-section-label">{section.section}</div>
              {items.map(item => (
                <button
                  key={item.page}
                  className={`nav-item ${currentPage === item.page ? 'active' : ''}`}
                  onClick={() => onNavigate(item.page)}
                >
                  <item.icon size={16} />
                  <span>{item.label}</span>
                  {currentPage === item.page && <ChevronRight size={14} style={{ marginLeft: 'auto' }} />}
                </button>
              ))}
            </div>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>
          {user?.name}<br />
          <span style={{ textTransform: 'capitalize' }}>{role}</span>
        </div>
      </div>
    </div>
  );
}
